// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.race-results-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.race-results-modal {
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 8px;
  max-width: 1000px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #334155;
  gap: 20px;
}

.modal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.race-results-modal .delete-button {
  background-color: #dc2626;
  border: none;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.race-results-modal .delete-button:hover:not(:disabled) {
  background-color: #b91c1c;
}

.race-results-modal .delete-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-title {
  flex: 1 1;
}

.modal-title h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.session-info {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #94a3b8;
}

.track-name,
.server-name,
.lap-info {
  display: flex;
  align-items: center;
}

.track-name::before {
  content: "📍 ";
  margin-right: 6px;
}

.server-name::before {
  content: "🖥️ ";
  margin-right: 6px;
}

.lap-info::before {
  content: "";
  margin-right: 2px;
}

.race-results-modal .close-button {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  flex-shrink: 0;
}

.race-results-modal .close-button:hover {
  color: #cbd5e1;
}

.results-table-container {
  flex: 1 1;
  overflow: auto;
}

.results-standings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.results-standings-table thead {
  background-color: #1e293b;
  position: sticky;
  top: 0;
  z-index: 10;
}

.results-standings-table th {
  padding: 14px 12px;
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
  border-bottom: 1px solid #334155;
  -webkit-user-select: none;
          user-select: none;
}

.results-standings-table tbody tr {
  border-bottom: 1px solid #334155;
  transition: background-color 0.2s;
}

.results-standings-table tbody tr:hover {
  background-color: #334155;
}

.results-standings-table tbody tr.winner {
  background-color: rgba(34, 197, 94, 0.1);
}

.results-standings-table tbody tr.winner:hover {
  background-color: rgba(34, 197, 94, 0.2);
}

.results-standings-table td {
  padding: 12px;
  color: #e2e8f0;
}

.col-position {
  width: 50px;
  text-align: center;
}

.col-driver {
  width: auto;
  flex: 1 1;
  min-width: 150px;
}

.col-car {
  width: auto;
  flex: 1 1;
  min-width: 180px;
}

.col-number {
  width: 50px;
  text-align: center;
}

.col-best-lap {
  width: 100px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.col-time {
  width: 100px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.col-penalty {
  width: 140px;
  text-align: left;
  font-family: 'Courier New', monospace;
}

.col-laps {
  width: 60px;
  text-align: center;
}

.col-gap {
  width: 120px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.penalty-summary-bar {
  padding: 12px 20px;
  background-color: #112e4a;
  border-bottom: 1px solid #334155;
  color: #cbd5e1;
  font-size: 13px;
}

.penalty-value {
  color: #fda4af;
  font-weight: 700;
}

.penalty-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
 .penalty-info {
   position: relative;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 24px;
   height: 24px;
   border-radius: 999px;
   background-color: rgba(148, 163, 184, 0.12);
   color: #cbd5e1;
   cursor: help;
 }

 .penalty-info:hover,
 .penalty-info:focus-visible {
   background-color: rgba(148, 163, 184, 0.2);
 }

 .penalty-tooltip {
   display: none;
   position: absolute;
   top: -100%;
   left: 50%;
   transform: translateX(-50%);
   min-width: 200px;
   max-width: 280px;
   padding: 10px 12px;
   border-radius: 8px;
   background-color: rgba(15, 23, 42, 0.96);
   color: #e2e8f0;
   font-size: 12px;
   line-height: 1.4;
   white-space: pre-wrap;
   box-shadow: 0 10px 24px rgba(15, 23, 42, 0.45);
   z-index: 5;
 }

 .penalty-info:hover .penalty-tooltip,
 .penalty-info:focus-visible .penalty-tooltip {
   display: block;
 }

.no-penalty {
  color: #94a3b8;
}

.race-results-modal .position-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 2px 6px rgba(2,6,23,0.6);
}

.race-results-modal .results-standings-table tbody tr.winner .position-badge {
  background-color: #22c55e;
}

.driver-name-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.driver-name {
  font-weight: 500;
  color: #f1f5f9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.car-model {
  color: #cbd5e1;
  font-size: 13px;
}

.race-results-modal .race-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 28px;
  padding: 0 6px;
  background-color: #111827;
  border-radius: 6px;
  font-weight: 700;
  color: #e2e8f0;
  font-size: 12px;
  border: 1px solid rgba(255,255,255,0.04);
}

.lap-time {
  color: #cbd5e1;
  font-weight: 500;
}

.lap-count {
  color: #cbd5e1;
  font-weight: 600;
  font-size: 14px;
}

.gap {
  color: #94a3b8;
}

.gap.leader {
  color: #22c55e;
  font-weight: 600;
}

.position-change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 999px;
  min-width: 28px;
  height: 24px;
  justify-content: center;
}

.position-change.gain {
  color: #10b981;
  background-color: rgba(16,185,129,0.08);
}

.position-change.loss {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.12);
}

.position-change.equal {
  color: #f59e0b;
  background-color: rgba(245, 158, 11, 0.08);
}

.position-change .equal-mark {
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  font-weight: 700;
}

.error-message {
  padding: 20px;
  background-color: #7f1d1d;
  border: 1px solid #dc2626;
  border-radius: 4px;
  color: #fecaca;
  font-size: 14px;
  text-align: center;
}

/* Scrollbar styling */
.results-table-container::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.results-table-container::-webkit-scrollbar-track {
  background-color: #1e293b;
}

.results-table-container::-webkit-scrollbar-thumb {
  background-color: #475569;
  border-radius: 4px;
}

.results-table-container::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}

@media (max-width: 768px) {
  .race-results-modal {
    max-height: 90vh;
  }

  .modal-header {
    padding: 16px;
  }

  .session-info {
    flex-direction: column;
    gap: 4px;
  }

  .col-car,
  .col-driver {
    min-width: 120px;
  }

  .car-model {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RaceResultsViewer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;CACC;GACE,kBAAkB;GAClB,oBAAoB;GACpB,mBAAmB;GACnB,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,oBAAoB;GACpB,2CAA2C;GAC3C,cAAc;GACd,YAAY;CACd;;CAEA;;GAEE,0CAA0C;CAC5C;;CAEA;GACE,aAAa;GACb,kBAAkB;GAClB,UAAU;GACV,SAAS;GACT,2BAA2B;GAC3B,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,kBAAkB;GAClB,wCAAwC;GACxC,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,qBAAqB;GACrB,8CAA8C;GAC9C,UAAU;CACZ;;CAEA;;GAEE,cAAc;CAChB;;AAED;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".race-results-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.race-results-modal {\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  max-width: 1000px;\r\n  width: 100%;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #334155;\r\n  gap: 20px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.race-results-modal .delete-button {\r\n  background-color: #dc2626;\r\n  border: none;\r\n  color: white;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.race-results-modal .delete-button:hover:not(:disabled) {\r\n  background-color: #b91c1c;\r\n}\r\n\r\n.race-results-modal .delete-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-title {\r\n  flex: 1;\r\n}\r\n\r\n.modal-title h2 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.session-info {\r\n  display: flex;\r\n  gap: 16px;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.track-name,\r\n.server-name,\r\n.lap-info {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.track-name::before {\r\n  content: \"📍 \";\r\n  margin-right: 6px;\r\n}\r\n\r\n.server-name::before {\r\n  content: \"🖥️ \";\r\n  margin-right: 6px;\r\n}\r\n\r\n.lap-info::before {\r\n  content: \"\";\r\n  margin-right: 2px;\r\n}\r\n\r\n.race-results-modal .close-button {\r\n  background: none;\r\n  border: none;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.race-results-modal .close-button:hover {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.results-table-container {\r\n  flex: 1;\r\n  overflow: auto;\r\n}\r\n\r\n.results-standings-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.results-standings-table thead {\r\n  background-color: #1e293b;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.results-standings-table th {\r\n  padding: 14px 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  border-bottom: 1px solid #334155;\r\n  user-select: none;\r\n}\r\n\r\n.results-standings-table tbody tr {\r\n  border-bottom: 1px solid #334155;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.results-standings-table tbody tr:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.results-standings-table tbody tr.winner {\r\n  background-color: rgba(34, 197, 94, 0.1);\r\n}\r\n\r\n.results-standings-table tbody tr.winner:hover {\r\n  background-color: rgba(34, 197, 94, 0.2);\r\n}\r\n\r\n.results-standings-table td {\r\n  padding: 12px;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.col-position {\r\n  width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.col-driver {\r\n  width: auto;\r\n  flex: 1;\r\n  min-width: 150px;\r\n}\r\n\r\n.col-car {\r\n  width: auto;\r\n  flex: 1;\r\n  min-width: 180px;\r\n}\r\n\r\n.col-number {\r\n  width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.col-best-lap {\r\n  width: 100px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-time {\r\n  width: 100px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-penalty {\r\n  width: 140px;\r\n  text-align: left;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-laps {\r\n  width: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.col-gap {\r\n  width: 120px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.penalty-summary-bar {\r\n  padding: 12px 20px;\r\n  background-color: #112e4a;\r\n  border-bottom: 1px solid #334155;\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.penalty-value {\r\n  color: #fda4af;\r\n  font-weight: 700;\r\n}\r\n\r\n.penalty-cell {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n .penalty-info {\r\n   position: relative;\r\n   display: inline-flex;\r\n   align-items: center;\r\n   justify-content: center;\r\n   width: 24px;\r\n   height: 24px;\r\n   border-radius: 999px;\r\n   background-color: rgba(148, 163, 184, 0.12);\r\n   color: #cbd5e1;\r\n   cursor: help;\r\n }\r\n\r\n .penalty-info:hover,\r\n .penalty-info:focus-visible {\r\n   background-color: rgba(148, 163, 184, 0.2);\r\n }\r\n\r\n .penalty-tooltip {\r\n   display: none;\r\n   position: absolute;\r\n   top: -100%;\r\n   left: 50%;\r\n   transform: translateX(-50%);\r\n   min-width: 200px;\r\n   max-width: 280px;\r\n   padding: 10px 12px;\r\n   border-radius: 8px;\r\n   background-color: rgba(15, 23, 42, 0.96);\r\n   color: #e2e8f0;\r\n   font-size: 12px;\r\n   line-height: 1.4;\r\n   white-space: pre-wrap;\r\n   box-shadow: 0 10px 24px rgba(15, 23, 42, 0.45);\r\n   z-index: 5;\r\n }\r\n\r\n .penalty-info:hover .penalty-tooltip,\r\n .penalty-info:focus-visible .penalty-tooltip {\r\n   display: block;\r\n }\r\n\r\n.no-penalty {\r\n  color: #94a3b8;\r\n}\r\n\r\n.race-results-modal .position-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  background-color: #3b82f6;\r\n  color: #ffffff;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  box-shadow: 0 2px 6px rgba(2,6,23,0.6);\r\n}\r\n\r\n.race-results-modal .results-standings-table tbody tr.winner .position-badge {\r\n  background-color: #22c55e;\r\n}\r\n\r\n.driver-name-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n}\r\n\r\n.driver-name {\r\n  font-weight: 500;\r\n  color: #f1f5f9;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  min-width: 0;\r\n}\r\n\r\n.car-model {\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.race-results-modal .race-number {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 30px;\r\n  height: 28px;\r\n  padding: 0 6px;\r\n  background-color: #111827;\r\n  border-radius: 6px;\r\n  font-weight: 700;\r\n  color: #e2e8f0;\r\n  font-size: 12px;\r\n  border: 1px solid rgba(255,255,255,0.04);\r\n}\r\n\r\n.lap-time {\r\n  color: #cbd5e1;\r\n  font-weight: 500;\r\n}\r\n\r\n.lap-count {\r\n  color: #cbd5e1;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.gap {\r\n  color: #94a3b8;\r\n}\r\n\r\n.gap.leader {\r\n  color: #22c55e;\r\n  font-weight: 600;\r\n}\r\n\r\n.position-change {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  padding: 2px 6px;\r\n  border-radius: 999px;\r\n  min-width: 28px;\r\n  height: 24px;\r\n  justify-content: center;\r\n}\r\n\r\n.position-change.gain {\r\n  color: #10b981;\r\n  background-color: rgba(16,185,129,0.08);\r\n}\r\n\r\n.position-change.loss {\r\n  color: #ef4444;\r\n  background-color: rgba(239, 68, 68, 0.12);\r\n}\r\n\r\n.position-change.equal {\r\n  color: #f59e0b;\r\n  background-color: rgba(245, 158, 11, 0.08);\r\n}\r\n\r\n.position-change .equal-mark {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  line-height: 12px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.error-message {\r\n  padding: 20px;\r\n  background-color: #7f1d1d;\r\n  border: 1px solid #dc2626;\r\n  border-radius: 4px;\r\n  color: #fecaca;\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.results-table-container::-webkit-scrollbar {\r\n  height: 8px;\r\n  width: 8px;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-track {\r\n  background-color: #1e293b;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-thumb {\r\n  background-color: #475569;\r\n  border-radius: 4px;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-thumb:hover {\r\n  background-color: #64748b;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .race-results-modal {\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .modal-header {\r\n    padding: 16px;\r\n  }\r\n\r\n  .session-info {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n\r\n  .col-car,\r\n  .col-driver {\r\n    min-width: 120px;\r\n  }\r\n\r\n  .car-model {\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
